const listMethods = {
  /*
  returns a list of options [{label: 'foo', value: 'bar'}]
  O(n)
  */
  toKeyValue: function () {
    return this.list.map(function (item) {
      return {
        label: item[0],
        value: item[1],
      };
    });
  },

  /*
  returns a hashmap of available options {foo: true, bar: true}]
  O(1)
  */
  getValuesMap: function () {
    const map = {};
    this.list.forEach(function (item) {
      map[item[1]] = true;
    });
    return map;
  },
  /*
  return a simple object {countryCode: countryName}
  O(n)
  */
  toObject: function () {
    const obj = {};
    this.list.forEach(function (item) {
      obj[item[1]] = item[0];
    });
    return obj;
  },
};

export const languages = Object.create(listMethods);
//https://developer.apple.com/library/content/documentation/LanguagesUtilities/Conceptual/iTunesConnect_Guide/Chapters/AppStoreTerritories.html
languages.list = [
  ['Abkhazian', 'ab'],
  ['Afar', 'aa'],
  ['Afrikaans', 'af'],
  ['Akan', 'ak'],
  ['Albanian', 'sq'],
  ['Amharic', 'am'],
  ['Arabic', 'ar'],
  ['Aragonese', 'an'],
  ['Armenian', 'hy'],
  ['Assamese', 'as'],
  ['Avaric', 'av'],
  ['Avestan', 'ae'],
  ['Aymara', 'ay'],
  ['Azerbaijani', 'az'],
  ['Bambara', 'bm'],
  ['Bashkir', 'ba'],
  ['Basque', 'eu'],
  ['Belarusian', 'be'],
  ['Bengali', 'bn'],
  ['Bihari languages', 'bh'],
  ['Bislama', 'bi'],
  ['Bosnian', 'bs'],
  ['Breton', 'br'],
  ['Bulgarian', 'bg'],
  ['Burmese', 'my'],
  ['Cantonese (Hong Kong)', 'zh-hk'],
  ['Catalan', 'ca'],
  ['Chamorro', 'ch'],
  ['Chechen', 'ce'],
  ['Chichewa', 'ny'],
  ['Chinese (China)', 'zh'],
  ['Chinese (Taiwan)', 'zh-tw'],
  ['Chinese (Singapore)', 'zh-sg'],
  ['Chuvash', 'cv'],
  ['Cornish', 'kw'],
  ['Corsican', 'co'],
  ['Cree', 'cr'],
  ['Croatian', 'hr'],
  ['Czech', 'cs'],
  ['Danish', 'da'],
  ['Divehi', 'dv'],
  ['Dutch', 'nl'],
  ['Dzongkha', 'dz'],
  ['English', 'en'],
  ['Esperanto', 'eo'],
  ['Estonian', 'et'],
  ['Ewe', 'ee'],
  ['Faroese', 'fo'],
  ['Fijian', 'fj'],
  ['Finnish', 'fi'],
  ['French', 'fr'],
  ['Fulah', 'ff'],
  ['Galician', 'gl'],
  ['Georgian', 'ka'],
  ['German', 'de'],
  ['Greek', 'el'],
  ['Guarani', 'gn'],
  ['Gujarati', 'gu'],
  ['Haitian', 'ht'],
  ['Hausa', 'ha'],
  ['Hebrew', 'he'],
  ['Herero', 'hz'],
  ['Hindi', 'hi'],
  ['Hiri Motu', 'ho'],
  ['Hungarian', 'hu'],
  ['Innu-aimun', 'moe'],
  ['Interlingua', 'ia'],
  ['Indonesian', 'id'],
  ['Interlingue', 'ie'],
  ['Irish', 'ga'],
  ['Igbo', 'ig'],
  ['Inupiaq', 'ik'],
  ['Ido', 'io'],
  ['Icelandic', 'is'],
  ['Italian', 'it'],
  ['Inuktitut', 'iu'],
  ['Japanese', 'ja'],
  ['Javanese', 'jv'],
  ['Kalaallisut', 'kl'],
  ['Kannada', 'kn'],
  ['Kanuri', 'kr'],
  ['Kashmiri', 'ks'],
  ['Kazakh', 'kk'],
  ['Central Khmer', 'km'],
  ['Kikuyu', 'ki'],
  ['Kinyarwanda', 'rw'],
  ['Kirghiz', 'ky'],
  ['Komi', 'kv'],
  ['Kongo', 'kg'],
  ['Korean', 'ko'],
  ['Kurdish', 'ku'],
  ['Kuanyama', 'kj'],
  ['Latin', 'la'],
  ['Luxembourgish', 'lb'],
  ['Ganda', 'lg'],
  ['Limburgan', 'li'],
  ['Lingala', 'ln'],
  ['Lao', 'lo'],
  ['Lithuanian', 'lt'],
  ['Luba-Katanga', 'lu'],
  ['Latvian', 'lv'],
  ['Manx', 'gv'],
  ['Macedonian', 'mk'],
  ['Malagasy', 'mg'],
  ['Malay', 'ms'],
  ['Malayalam', 'ml'],
  ['Maltese', 'mt'],
  ['Maori', 'mi'],
  ['Marathi', 'mr'],
  ['Marshallese', 'mh'],
  ['Mongolian', 'mn'],
  ['Nauru', 'na'],
  ['Navajo', 'nv'],
  ['North Ndebele', 'nd'],
  ['Nepali', 'ne'],
  ['Ndonga', 'ng'],
  ['Norwegian Bokmål', 'nb'],
  ['Norwegian Nynorsk', 'nn'],
  ['Norwegian', 'no'],
  ['Sichuan Yi', 'ii'],
  ['South Ndebele', 'nr'],
  ['Occitan', 'oc'],
  ['Ojibwa', 'oj'],
  ['Church Slavic', 'cu'],
  ['Oromo', 'om'],
  ['Oriya', 'or'],
  ['Ossetian', 'os'],
  ['Punjabi', 'pa'],
  ['Pali', 'pi'],
  ['Persian', 'fa'],
  ['Polish', 'pl'],
  ['Pashto', 'ps'],
  ['Portuguese', 'pt'],
  ['Quechua', 'qu'],
  ['Romansh', 'rm'],
  ['Rundi', 'rn'],
  ['Romanian', 'ro'],
  ['Russian', 'ru'],
  ['Sanskrit', 'sa'],
  ['Sardinian', 'sc'],
  ['Sindhi', 'sd'],
  ['Northern Sami', 'se'],
  ['Southern Sami', 'sma'],
  ['Samoan', 'sm'],
  ['Sango', 'sg'],
  ['Serbian', 'sr'],
  ['Gaelic', 'gd'],
  ['Shona', 'sn'],
  ['Sinhala', 'si'],
  ['Slovak', 'sk'],
  ['Slovenian', 'sl'],
  ['Somali', 'so'],
  ['Southern Sotho', 'st'],
  ['Spanish', 'es'],
  ['Sundanese', 'su'],
  ['Swahili', 'sw'],
  ['Swati', 'ss'],
  ['Swedish', 'sv'],
  ['Tamil', 'ta'],
  ['Telugu', 'te'],
  ['Tajik', 'tg'],
  ['Taiwanese Hokkien', 'zh-Hant'],
  ['Thai', 'th'],
  ['Tigrinya', 'ti'],
  ['Tibetan', 'bo'],
  ['Turkmen', 'tk'],
  ['Tagalog', 'tl'],
  ['Tswana', 'tn'],
  ['Tonga', 'to'],
  ['Turkish', 'tr'],
  ['Tsonga', 'ts'],
  ['Tatar', 'tt'],
  ['Twi', 'tw'],
  ['Tahitian', 'ty'],
  ['Uighur', 'ug'],
  ['Ukrainian', 'uk'],
  ['Urdu', 'ur'],
  ['Uzbek', 'uz'],
  ['Venda', 've'],
  ['Vietnamese', 'vi'],
  ['Volapük', 'vo'],
  ['Walloon', 'wa'],
  ['Welsh', 'cy'],
  ['Wolof', 'wo'],
  ['Western Frisian', 'fy'],
  ['Xhosa', 'xh'],
  ['Yiddish', 'yi'],
  ['Yoruba', 'yo'],
  ['Zhuang', 'za'],
  ['Zulu', 'zu'],
];

export const appLanguages = [
  {
    label: 'Navigator Language',
    code: 'default',
  },
  {
    label: 'English',
    code: 'en',
  },
  {
    label: 'French',
    code: 'fr',
  },
  {
    label: 'German',
    code: 'de',
  },
  {
    label: 'Spanish',
    code: 'es',
  },
  {
    label: 'Swedish',
    code: 'sv',
  },
  {
    label: 'Danish',
    code: 'da',
  },
  {
    label: 'Norwegian',
    code: 'no',
  },
];

export const genders = Object.create(listMethods);

genders.list = [
  ['Male', 'male'],
  ['Female', 'female'],
];

export const incomes = Object.create(listMethods);

incomes.list = [
  ['< $40K', '0-40'],
  ['$40K-60K', '40-60'],
  ['$60K-80K', '60-80'],
  ['$80K-100K', '80-100'],
  ['> $100K', '100-200'],
];

export const ageGroups = Object.create(listMethods);

ageGroups.list = [
  ['18-24', '18-24'],
  ['25-34', '25-34'],
  ['35-44', '35-44'],
  ['45-54', '45-54'],
  ['55+', '55-100'],
];

export const awsRegions = Object.create(listMethods);

awsRegions.list = [
  ['US East (Ohio)', 'us-east-2'],
  ['US East (N. Virginia)', 'us-east-1'],
  ['US West (N. California)', 'us-west-1'],
  ['US West (Oregon)', 'us-west-2'],
  ['Asia Pacific (Mumbai)', 'ap-south-1'],
  ['Asia Pacific (Seoul)', 'ap-northeast-2'],
  ['Asia Pacific (Singapore)', 'ap-southeast-1'],
  ['Asia Pacific (Sydney)', 'ap-southeast-2'],
  ['Asia Pacific (Tokyo)', 'ap-northeast-1'],
  ['Canada (Central)', 'ca-central-1'],
  ['China (Beijing)', 'cn-north-1'],
  ['China (Ningxia)', 'cn-northwest-1'],
  ['EU (Frankfurt)', 'eu-central-1'],
  ['EU (Ireland)', 'eu-west-1'],
  ['EU (London)', 'eu-west-2'],
  ['EU (Paris)', 'eu-west-3'],
  ['South America (São Paulo)', 'sa-east-1'],
];

export const isIndianLanguage = function (language) {
  return (
    language === 'hi' ||
    language === 'ta' ||
    language === 'te' ||
    language === 'ml' ||
    language === 'bn'
  );
};

export const locales = {
  '': 'default',
  'en-US': 'en',
  'fr-FR': 'fr',
  'de-DE': 'de',
  'es-ES': 'es',
  'sv-SE': 'sv',
  'da-DK': 'da',
  'no-NO': 'no',
};

export default {
  genders,
  incomes,
  ageGroups,
  languages,
  appLanguages,
  awsRegions,
  locales,
  isIndianLanguage,
};
